module.exports = __webpack_public_path__ + "static/img/popup_dis.ac990071.svg";